<app-page inTutorial="true">
  <create-post-form [inTutorial]="true"></create-post-form>
</app-page>
